import type { SVGProps } from "react";

export function RestaurantIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.60625 13.676L10.5664 10.7159L4.09173 4.25169C3.58966 3.74961 2.72149 3.88559 2.40769 4.5341C1.66504 6.09263 1.937 8.00678 3.22356 9.30381L7.60625 13.676ZM14.698 11.7828C16.2984 12.5254 18.5473 12.0025 20.2104 10.3393C22.2082 8.3415 22.5952 5.47549 21.0576 3.93789C19.5305 2.41075 16.6645 2.78731 14.6562 4.78514C12.9931 6.44826 12.4701 8.69713 13.2127 10.2975L3.7361 19.7741C3.32816 20.1821 3.32816 20.841 3.7361 21.249C4.14403 21.6569 4.803 21.6569 5.21094 21.249L11.6856 14.7952L18.1498 21.2594C18.5577 21.6674 19.2167 21.6674 19.6246 21.2594C20.0326 20.8515 20.0326 20.1925 19.6246 19.7846L13.1604 13.3204L14.698 11.7828Z"
        fill="currentColor"
      />
    </svg>
  );
}
